import { Component, OnInit } from "@angular/core";
import { AuthService } from "app/core/services/auth.service";
import { environment } from "../../../../environments/environment";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { CustomError } from "app/core/models/custom-error";

@Component({
  selector: "app-password-reset",
  templateUrl: "./password-reset.component.html",
  styleUrls: ["./password-reset.component.scss"]
})
export class PasswordResetComponent implements OnInit {
  newPassword: string;
  c_newPassword: string;

  isTokenValid: boolean = false;
  token: string;
  email: string;

  // callback: string = environment.APP_ROOT; //environment
  // requestInProgress: boolean = false;
  // resetRequestSent: boolean = false;

  passwordResetDone: boolean = false;
  error: string = null;

  actionError: CustomError;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  async ngOnInit() {

    this.passwordResetDone = false;

    const passwordToken = this.route.snapshot.queryParams["token"];

    try {
      const passwordReset: any = await this.authService.verifyPasswordResetToken(
        passwordToken
      );

      // console.log(passwordReset);
// 
      if (passwordReset) {
        //show reset page
        this.isTokenValid = true;
        this.email = passwordReset.email;
        this.token = passwordReset.token;
      }
    } catch (error) {

      this.isTokenValid = false;

      this.actionError = new CustomError(null, "Invalid Token", "Token provided is invalid.", null);

      console.log(error);
    }




    // this.route.queryParams.subscribe((params: Params) => {
    //   console.log(params);

    //   (async () => {
    //     try {
    //       const passwordReset: any = await this.authService.verifyPasswordResetToken(
    //         params["token"]
    //       );

    //       console.log(passwordReset);

    //       if (passwordReset) {
    //         //show reset page
    //         this.isTokenValid = true;
    //         this.email = passwordReset.email;
    //         this.token = passwordReset.token;
    //       }
    //     } catch (error) {

    //       this.isTokenValid = false;

    //       console.log(error);
    //     }
    //   })();
    // });
  }

  resetPassword() {
    if (this.newPassword == this.c_newPassword) {
      this.authService
        .resetPassword(this.email, this.newPassword, this.token)
        .then(
          result => {
            //reset sucess.
            if (result) {
              this.passwordResetDone = true;
            }
          },
          error => { }
        );
    }
  }
}
